/**
 * @file Created on Fri Feb 01 2019
 * @author SKu
 */
import FlagsRenderer from './FlagsRenderer';
export default FlagsRenderer;